import React, { useState, useEffect } from 'react';
import { Row, Col, FloatingLabel, Tooltip, OverlayTrigger,
  Form, Dropdown, DropdownButton,
  Button, ButtonGroup, Modal, Offcanvas  } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";




import recordsIcon from '../../dist/images/icons/menu/records.png'
import amountIcon from '../../dist/images/icons/menu/amount.png'
import categoryIcon from '../../dist/images/icons/menu/category.png'
import accountIcon from '../../dist/images/icons/menu/account.png'
import dateIcon from '../../dist/images/icons/menu/date.png'
import dashIcon from '../../dist/images/icons/menu/dashboard.png'
import docIcon from '../../dist/images/icons/document.png'

const App = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const {id} = useParams()


  const [recordData, setRecordData] = useState({
    name: '',
    category: null,
    account: null,
    date: '',
    amount: ''
  })

  const isViewPage =  location.pathname.includes('/view/') ;


  
  


  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => onCloseFrom();
  const handleAddShow = () => setAddShow(true);

    



  const [error, setError] = useState({});
  const [editId, setEditId] = useState(null);

  const [categoryOptions, setCategoryOptions] =useState([])

  // useEffect(() => {
  //   console.log("RecordData", recordData, categoryOptions)
  // }, [recordData, categoryOptions])



  const onCloseFrom = () => {
    setRecordData({
      name: '',
      category: null,
      account: null,
      date: '',
      amount: ''
    });
    setError({});
    setAddShow(false);
    navigate('/records/', { state: { onFetchData: true } })
    setEditId(null)
  }

  const accountOption = [
  {id:1, value :"Cash"},
  {id : 2, value :"Debit Card"},
  {id :3, value :"Credit Card"},
  ]

  useEffect(() => {
    if(id && isViewPage){
      setEditId(id)
    }
  }, [id, isViewPage])

  useEffect(() => {
    if(editId){
      setAddShow(true)
      fetchEditData()
    }
  }, [ editId])

  useEffect(()=>{
    axios.get(`${apiUrl}Category/`)
    .then(response => {
      //console.log(response.data);
      const data = response.data;
      setCategoryOptions(data)

    })
    .catch(error => {
      console.error('Error fetching data: ', error,);
    });
  },[])


  const fetchEditData = () => {
    axios.get(`${apiUrl}Records/${editId}`)
    .then(response => {
      // console.log(response.data);
      const data = response.data;
      setRecordData(data)


    })
    .catch(error => {
      console.error('Error fetching data: ', error,);
    });
  }

  


  const validation = () => {
    const newError = {};
    if (!recordData.name.trim()) {
      newError.name = "Name is required";
    }
    if (!recordData.category) {
      newError.category = "Category is required";
    }
    if (!recordData.date) {
      newError.date = "Date is required";
    }
    if (!recordData.account) {
      newError.account = "Account is required";
    }
    if (!recordData.amount) {
      newError.amount = "Amount is required";
    }
    return newError;
  };

  const handleCreateTemplateSubmit = async (e) => {
    e.preventDefault();
    const validationForm = validation();

    if (Object.keys(validationForm).length > 0) {
      setError(validationForm);
    } else {
      


      let sendApi = `${apiUrl}/Records/`
      if (editId) {
        sendApi = `${apiUrl}/Records/${editId}`
      }

      const method = editId ? 'put' : 'post';

      axios({
          method: method, 
          url: sendApi,
          data: recordData, 
        })
        .then((response) => {
          onCloseFrom()          
          toast.success("Category Data Submitted")

        })
        .catch((error) => {
          console.error("Error submitting form:", error, `${process.env.REACT_APP_API}/Category/`, recordData);
        });
    }
  };

  

  const handleRecordDataChange = (value, field) => {

    setRecordData(prevData => ({
      ...prevData,
      [field]: value
    }))


    setError(prevError => ({
      ...prevError,
      [field]: ''
    }))

  }

  return (
    <>
      <Offcanvas
        show={addShow}
        onHide={handleAddClose}
        placement="end"
        size="lg"
        style={{
          height: "100vh", // Fill full height
          width: "700px",
        }}
      >
        <Offcanvas.Header closeButton className="pb-0" >
          <Offcanvas.Title>
          <h3 className="fw-bold mt-2 ms-4">{recordData?.name}</h3>
          
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="ms-4">

          <p className="des"><img src={docIcon} className="opacity-05 me-2" width="20"/>Created by <span className="fw-bold"> Admin</span> on {new Date(recordData.date).toLocaleDateString()}</p>
         <div class="mb-2 view-single-data mt-4 row">
          <div class="col-md-4">
          <p class="cl-grey-3 task-data-title">
          <img src={recordsIcon} width="20" style={{marginRight: "15px"}}/> Name   </p></div>
          <div class="col-md-8"><p>{recordData?.name}</p></div></div>
          <div class="mb-2 view-single-data row ">
          <div class="col-md-4">
          <p class="cl-grey-3 task-data-title">
          <img src={amountIcon} width="25" style={{marginRight: "10px"}}/> Amount   </p></div>
          <div class="col-md-8"><p><span className={`${recordData.categoryType === "1" ? 'cl-red' : 'cl-green'}`}> &#8377; {recordData?.amount}</span></p></div></div>
          

          <div class="mb-2 view-single-data row">
          <div class="col-md-4">
          <p class="cl-grey-3 task-data-title">
          <img src={dashIcon} width="20" style={{marginRight: "15px"}}/> Category Type  </p></div>
          <div class="col-md-8"><p>{recordData.categoryType === "1" ? 'Expense' : 'Income'}</p></div></div>
          


          <div class="mb-2 view-single-data row">
          <div class="col-md-4">
          <p class="cl-grey-3 task-data-title">
          <img src={categoryIcon} width="25" style={{marginRight: "10px"}}/> Category   </p></div>
          <div class="col-md-8"><p>{categoryOptions?.find(category => parseInt(category.id) === parseInt(recordData.category))?.Category}</p></div></div>
          <div class="mb-2 view-single-data row">
          <div class="col-md-4">
          <p class="cl-grey-3 task-data-title">
          <img src={accountIcon} width="20" style={{marginRight: "15px"}}/> Account   </p></div>
          <div class="col-md-8"><p> {accountOption?.find(acc => parseInt(acc.id) === parseInt(recordData.account))?.value}</p></div></div>
          <div class="mb-2 view-single-data row">
          <div class="col-md-4">
          <p class="cl-grey-3 task-data-title">
          <img src={dateIcon} width="25" style={{marginRight: "10px"}}/> Date   </p></div>
          <div class="col-md-8"><p>{recordData?.date ? new Date(recordData.date).toLocaleDateString(): '-'}</p></div></div>


        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default App;
